"use client"

import styled from "@emotion/styled"
import FormHelperErrorIcon from "../ui/icons/FormHelperErrorIcon"
import FormHelperValidIcon from "../ui/icons/FormHelperValidIcon"

const StyledContainer = styled.p`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
  align-self: baseline;
`

type Props = {
  render: boolean
  error: boolean
  text?: string
  locale?: string
  id?: string
}

function CustomHelperText({ render, error, text, id }: Props) {
  if (!render || !error) return null
  return (
    <StyledContainer role="alert" id={id}>
      {error ? <FormHelperErrorIcon /> : <FormHelperValidIcon />}
      <p
        style={{
          margin: 0,
          width: "100%",
          color: error ? "#C92418" : "#008015",
          marginRight: "4px",
          fontSize: "12px",
        }}
      >
        {text || "הושלם"}
      </p>
    </StyledContainer>
  )
}

export default CustomHelperText
